import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _classPrivateFieldSet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldSet";
import _classPrivateFieldGet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldGet";
import _setTimeout from "@babel/runtime-corejs3/core-js/set-timeout";
import _WeakMap from "@babel/runtime-corejs3/core-js/weak-map";
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
import React from "react";
import PropTypes from "prop-types";
import classesPropType from "@xo-union/classes-prop-type";
import Alert from "../Alert/index.js";
const DEFAULT_WAIT_TIME = 3000; /* 3 seconds */
var _timeout = /*#__PURE__*/new _WeakMap();
export default class ControlledAlert extends React.Component {
  constructor() {
    super(...arguments);
    _classPrivateFieldInitSpec(this, _timeout, {
      writable: true,
      value: null
    });
    _defineProperty(this, "state", {
      visible: this.props.visible,
      content: this.props.children,
      type: this.props.type
    });
  }
  componentWillUnmount() {
    // Avoid calling setState when unmounted
    clearTimeout(_classPrivateFieldGet(this, _timeout));
  }
  isVisible() {
    return this.state.visible;
  }
  show(_ref) {
    let {
      content,
      type
    } = _ref;
    this.setState({
      content,
      type,
      visible: true
    });
  }
  showAndDismiss() {
    let {
      type,
      content,
      waitTime = DEFAULT_WAIT_TIME
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.show({
      type,
      content
    });
    _classPrivateFieldSet(this, _timeout, _setTimeout(() => {
      this.dismiss();
    }, waitTime));
  }
  dismiss() {
    this.setState({
      visible: false
    });
  }
  render() {
    const {
      position,
      classes,
      visible,
      type,
      children,
      ...rest
    } = this.props;
    return /*#__PURE__*/React.createElement(Alert, _extends({
      visible: this.state.visible,
      type: this.state.type,
      position: position,
      classes: classes
    }, rest), this.state.content);
  }
}
process.env.NODE_ENV !== "production" ? ControlledAlert.propTypes = {
  /**
   * Hydrate initial visibility state (useful for server side rendering)
   */
  visible: PropTypes.bool,
  /**
   * Hydrate initial content (useful for server side rendering)
   */
  children: PropTypes.node,
  /**
   * Hydrate initial type (useful for server side rendering)
   */
  type: PropTypes.oneOf(['error', 'info']),
  /**
   * Position in container
   */
  position: PropTypes.oneOf(['top', 'bottom']),
  /**
   * Class dependencies
   */
  classes: classesPropType(['container', 'is-visible', 'is-not-visible', 'type-error', 'type-info', 'position-top', 'position-bottom'])
} : void 0;